import { Middleware } from '@reduxjs/toolkit';
// import errorService from '../services/errorService';

export const fetchErrorsMiddleware: Middleware = () => next => action => {
  const regex = new RegExp('_failure|_FAILURE');

  if (regex.test(action.type)) {
    // errorService.catch(action.payload);
  }
  next(action);
};
